import ModificarInversionModal from "./ModificarInversionModal";
export default ModificarInversionModal;